import { z } from 'zod';
import { initContract } from '@ts-rest/core';
import { ping } from './shared.js';
import { ObjectIdString } from '@repo/common/schemas';
import { AccountDTO } from '@repo/common/schemas/models';
const c = initContract();

export const embeddedContract = c.router(
  {
    authenticate: {
      method: 'POST',
      path: '/authenticate',
      headers: {
        Authorization: z.string().optional(),
      },
      body: z.object({
        corpId: z.string(),
        bullhornUserId: z.string().describe('Bullhorn user sourceId or username'),
        authCode: z.string().optional(),
      }),
      responses: {
        200: z.object({
          accountId: ObjectIdString,
          account: AccountDTO,
          corpId: z.string(),
          /** @deprecated ambiguously named; we should use recruiterId or authUserId */
          userId: ObjectIdString,
          sessionId: z.string(),
          sessionToken: z.string(),
          userEmail: z.string().nullable(),
          recruiterId: ObjectIdString.describe('Bullhorn recruiter _id'),
          authUserId: ObjectIdString.nullish().describe('AuthUser _id'),
          departmentKey: z.array(z.string()).nullable(),
        }),
      },
    },
  },
  {
    pathPrefix: '/embedded',
    baseHeaders: {
      'toro-session-id': z.string().optional(),
      'toro-user-id': z.string().optional(),
    },
  }
);
